import { LS } from '@/helpers/localStorageHelper';
import { queryString } from '@/helpers/queryString';
import { defaultLanguage, getLocaleLang } from '@/config/constants';

export const getLanguageFromLocation = () => {
  const { location } = typeof window === 'undefined' ? {} : window;
  if (!location) return defaultLanguage;
  const { search } = location;
  const { locale } = queryString(search);
  const savedLang = LS.get('locale');

  if (!locale) {
    return savedLang || defaultLanguage;
  }

  return getLocaleLang(locale);
};
